export default "__VITE_ASSET__DiqfIuDQ__"